// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Route, Routes } from 'react-router-dom';
import Loading from '../components/Loading';
import { useParties } from '../contexts/PartiesContext';
import useBridgeUserAgreement from '../hooks/queries/bridge/agreement/useBridgeUserAgreement';
import { CommonBridgeLayout } from '../layout/CommonBridgeLayout';
import { Deposits } from '../pages/bridge/deposits/Deposits';
import { Holdings } from '../pages/bridge/holdings/Holdings';
import { Onboarding } from '../pages/bridge/onboarding/Onboarding';
import { ModuleRoute } from '../routes/types';
import { Configurations } from '../pages/bridge/configuration/Configurations';
import { Withdrawals } from '../pages/bridge/withdrawals/Withdrawals';
import { Admin } from '../pages/bridge/admin/Admin';

const sidebarEntries: ModuleRoute[] = [
  { label: 'Onboarding', path: 'onboarding', element: <Onboarding /> },
];

const configurationEntry: ModuleRoute = {
  label: 'Configurations',
  path: 'configurations',
  element: <Configurations />,
 };

const adminEntry: ModuleRoute = {
  label: 'Admin',
  path: 'admin',
  element: <Admin />,
};

const holderEntries: ModuleRoute[] = [
  { label: 'Holdings', path: 'holdings', element: <Holdings /> },
  { label: 'Deposits', path: 'deposits', element: <Deposits /> },
  { label: 'Withdrawals', path: 'withdrawals', element: <Withdrawals /> },
];

export const Bridge: React.FC = () => {
  const bridgeUserAgreement = useBridgeUserAgreement();
  const { bridgeOperator, party } = useParties();

  const { isLoading } = bridgeUserAgreement;
  if (isLoading) return <Loading />;

  const isHolder = !!bridgeUserAgreement.data;
  const isBridgeOperator = bridgeOperator === party;

  let entries = sidebarEntries;
  if (isBridgeOperator) {
    entries = entries.concat([configurationEntry, adminEntry]).concat(holderEntries);
  } else if (isHolder) entries = entries.concat(holderEntries);

  return (
    <CommonBridgeLayout entries={entries}>
      <Routes>
        {entries.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Routes>
    </CommonBridgeLayout>
  );
};
